<template>
	<div class="pages">
		<div class="applyTop">
			<div class="flex flex-align-center flex-jus-between">
				<img src="@/static/images/icon-arrowLeft.png" class="arrow" @click="goBack"/>
				<img src="@/static/images/icon-my.png" class="arrow" @click="$router.push({name: 'my'})"/>
			</div>
			<div class="avatar flex flex-align-center flex-jus-center">
				<img :src="avatar" alt="" />
			</div>
			<div class="name flex flex-align-center flex-jus-center">
				<div>{{truename || nickname}}</div>
				<img v-if="is_vip == 1" src="@/static/images/my/memberIDF.png" class="idf">
			</div>
		</div>
		<div class="list">
			<div class="infoBox">
				<div class="infoBox-title">福建省民族管弦乐学会</div>
				<div class="infoBox-tips" v-show="initiation_time">
					您从{{ initiation_time | formatDate_noS }}起加入学会
				</div>
			</div>
			
			<div class="infoMoney">
				<div class="title">缴纳会费</div>
				<div class="money">
					<span style="font-size: 13px;margin-right: 4px;">¥</span>{{commonConfig.vip_apply_price}}
				</div>
				<div class="tips">需缴纳会费</div>
				<div class="time">{{nowDate}}-{{nextDate}}</div>
			</div>
			
		</div>
		
		<div class="fixedBottom flex flex-align-center flex-jus-between">
			<div class="left flex-1 flex flex-align-center">
				<span>合计：</span>
				<span class="money">￥{{commonConfig.vip_apply_price}}</span>
			</div>
			<div @click="pay" class="payBtn">立即支付</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	import {mapState} from 'vuex'
	export default {
		watch: {
		},
		data() {
			return{
				avatar: '',
				nickname: '',
				truename: '',
				is_vip: 0,
				vip: {},
				initiation_time: null,
				nowDate: '',
				nextDate: ''
			}
		},
		computed: {
			...mapState(['commonConfig']),
		},
		created() {
			this.getUserInfo()
			this.nowDate = this.moment().format('YYYY-MM-DD')
			this.nextDate = this.moment().add(1, 'year').format('YYYY-MM-DD')
		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			goBack() {
				if (window.history.length <=1 ) {
					this.$router.push('/home')
				} else {
					this.$router.back(-1)
				}
			},
			getUserInfo() {
				this.$get('api/user/userInfo').then(res => {
					let result = res.data
					this.avatar = result.avatar
					this.nickname = result.nickname
					this.truename = result.truename
					this.is_vip = result.is_vip
					if (!Array.isArray(result.vip)) {
						this.vip = result.vip || {}
						this.initiation_time = this.vip.initiation_time
					}
				})
			},
			pay() {
				this.$post('api/pay/unifyOrder', {
					type: 2,
					relation_id: localStorage.getItem('user_id')
				}).then(res => {
					this.makeApply(res.data.order_no)
				})
			},
			makeApply(order_no) {
				this.$post('api/pay/unifyPay', {
					order_no,
					pay_type: 1,
					is_jssdk: 1
				}).then(res => {
					this.$wx.chooseWXPay({
						timestamp: res.data.timeStamp,
						nonceStr: res.data.nonceStr,
						package: res.data.package,
						signType: 'MD5',
						paySign: res.data.paySign,
						success: (ress) => {
							if (ress.errMsg === 'chooseWXPay:ok') {
								this.$toast('支付成功')
								setTimeout(() => {
									this.$router.go(-1)
								}, 750);
							} else {
								this.$toast('支付失败')
							}
						}
					})
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
.pages
	background: #F6F6F6;
	min-height 100vh
	padding-bottom 120px

.fixedBottom
	position fixed
	bottom 0
	left 0
	width 100%
	height: 100px;
	background: #FFFFFF;
	box-shadow: 0px -6px 24px rgba(0, 0, 0, 0.05);
	padding 10px 30px
	.money
		color: #DE113C;
		font-weight bold
	.left
		font-size 26px
		color #111111
	.payBtn
		width 272px
		height 80px
		line-height 80px
		text-align center
		background-image url('~@/static/images/index/btnBG.png')
		background-size 100% 100%
		background-position center
		font-size: 32px;
		font-weight: 500;
		color: #FFFFFF;
.list
	padding 0 30px
	background-color transparent
	position relative
	top -76px
	.infoMoney
		width 100%
		background: #FFFFFF;
		border-radius: 20px;
		margin-top 28px
		padding 24px
		.title
			width 100%
			background-image url('~@/static/images/my/apply-circle.png')
			background-position left top
			background-size 38px 46px
			background-repeat no-repeat
			padding-left 12px
			padding-top 6px
			font-size: 32px;
			font-weight: bold;
			color: #000000;
			margin-bottom 28px
		.money
			width 100%
			text-align center
			font-size: 44px;
			font-weight: bold;
			color: #DE113C;
		.tips
			margin-top 10px
			width 100%
			text-align center
			font-size: 24px;
			color: #B1B1B1;
		.time
			margin-top 40px
			width 100%
			text-align center
			font-size: 24px;
			color: #000000;
	.infoBox
		width 100%
		height: 152px;
		background: #FFFFFF;
		border-radius: 20px;
		padding 30px 24px
		background-image url('~@/static/images/my/infoBoxBG.png')
		background-size 162px 145px
		background-repeat no-repeat
		background-position right top
		.infoBox-title
			font-size: 30px;
			font-weight: bold;
			color: #000000;
		.infoBox-tips
			margin-top 14px
			font-size: 24px;
			color: #B1B1B1;
.applyTop
	background: #DE113C;
	width 100vw
	height: 356px;
	padding 24px 30px
	.arrow
		width 52px
		height 52px
	.avatar
		background-image url('~@/static/images/my/avatarBG.png')
		background-size 100% 100%
		background-position center
		width 120px
		height 120px
		margin 0 auto
		margin-top -50px
		img
			width 90px
			height 90px
			border-radius 50%
	.name
		margin-top 14px
		text-align center
		width 100%
		font-size 32px
		font-weight 800
		color #FFEBE8
		.idf
			width 38px
			height 38px
			margin-left 14px
</style>
